<template>
  <div>
    <v-app-bar color="deep-purple" dark>
      <v-row class="d-flex" justify="center" align="center">
        <!-- Make KASANA AUTO GARAGE a clickable link to homepage -->
        <router-link to="/" class="white--text text-decoration-none">
          <v-toolbar-title>KASANA AUTO GARAGE</v-toolbar-title>
        </router-link>

        <v-spacer></v-spacer>
        <router-link
          v-for="(detail, id) in details"
          :key="id"
          class="white--text mx-4 text-decoration-none hidden-sm-and-down"
          :to="detail.routeName"
        >
          {{ detail.name }}
        </router-link>
        <v-app-bar-nav-icon
          class="hidden-sm-and-up"
          @click="drawer = true"
        ></v-app-bar-nav-icon>
      </v-row>
    </v-app-bar>

    <v-navigation-drawer
      height="100vh"
      class="mt-14"
      v-model="drawer"
      absolute
      temporary
    >
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <router-link
            v-for="(item, index) in details"
            :key="index"
            :to="item.routeName"
            class="text-decoration-none"
          >
            <v-list-item @click="drawer = false">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "HeaderComponent",
  data() {
    return {
      drawer: false,
      group: null,
      details: [
        { name: "Home", routeName: "/", icon: "mdi-home" },
        { name: "Service", routeName: "/services", icon: "mdi-tools" },
        { name: "Vehicle List", routeName: "/vehicle-list", icon: "mdi-car" },
        { name: "Customers", routeName: "/customers", icon: "mdi-account" },
        { name: "About Us", routeName: "/about", icon: "mdi-information" },
        { name: "Contact Us", routeName: "/contact", icon: "mdi-phone" },
        { name: "Register", routeName: "/register", icon: "mdi-account-plus" },
        { name: "Login", routeName: "/login", icon: "mdi-login" },
      ],
    };
  },
};
</script>
